import { cn } from '@/lib/utils';

/**
 * Evidence basis for a metric/finding. Only the non-measured bases render a
 * badge — "measured" is the default expectation and would just add noise.
 * "measured" and "derived" are both grounded in real collected data (a ratio
 * of two real numbers is still trustworthy) — no badge, by design. Only
 * "benchmark"/"assumed" get a visible caveat, since those are the ones a
 * reader could otherwise mistake for a real measurement.
 *
 * (Moved out of tabs/ExecutiveSummary.tsx — it is shared by several tabs and
 * a widget has no business being exported from a tab.)
 */
const BASIS_LABELS: Record<string, string> = {
  benchmark: 'benchmark',
  assumed: 'estimate',
};

export default function BasisBadge({ basis, className }: { basis?: unknown; className?: string }) {
  const label = typeof basis === 'string' ? BASIS_LABELS[basis] : undefined;
  if (!label) return null;
  return (
    <span
      className={cn(
        'inline-block shrink-0 rounded bg-muted px-1 py-px align-middle font-mono text-[10px] font-medium uppercase tracking-wide text-muted-foreground',
        className,
      )}
    >
      {label}
    </span>
  );
}
